import React, { useEffect, useState } from 'react';
import {
    XMarkIcon,
    UserIcon,
    PhoneIcon,
    MapPinIcon,
    CalendarIcon,
    EnvelopeIcon,
    DocumentTextIcon,
    CurrencyDollarIcon,
    ChatBubbleBottomCenterTextIcon,
    ArrowUpTrayIcon,
    CheckIcon,
    PlusIcon
} from '@heroicons/react/24/outline';
import { APIURL } from '../../../configApi/apiConfig';
import axios from '../../../configApi/axiosConfig';
import { SaveGestion } from '../SaveGestion/SaveGestion';
import { CellTower } from '@mui/icons-material';
import { TelefonosNuevos } from '../TelefonosNuevos';

import { HistorialCobranza } from '../../historialCobranza'
import simplia from '../../../img/simplia.png';
import { CardVerificacionTelefonica } from './CardVerificacionTelefonica';
import { InfoDireccion } from './InfoDireccion';
import { HistorialGestiones } from './HistorialGestiones';
import { useSip } from '../../SipContext';
export function DetalleCobranza({ isOpen, onClose, data, estadoGestion, item }) {
    const { openDialer, phoneAvailable } = useSip();

    const [formData, setFormData] = useState({
        fecha: new Date().toLocaleDateString('es-EC'),
        vendedor: '',
        telefono: '',
        dato: '',
        direccion: '',
        tipoContacto: '',
        descripcion: '',
        fechaPago: '',
        valor: '0.00',
        emailOperador: '',
        emailCliente: '',
        archivo: null,
        observacion: ''
    });


    const [showSaveGestion, setShowSaveGestion] = useState(false);
    // Estado para acordeones
    const [showDireccion, setShowDireccion] = useState(false);
    const [showVerificacion, setShowVerificacion] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [tipoContactoData, setTipoContacto] = useState([]);
    const [selectResultado, setSelectResultado] = useState([]);
    const [direccionData, setDireccionData] = useState(null);
    const [datosCobranza, setDatosCobranza] = useState(null);
    const [historialAPI, setHistorialAPI] = useState([]);
    const [showTelefonos, setShowTelefonos] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    useEffect(() => {
        if (isOpen && data && data.sCre_SolicitudWeb) {
            fetchSelectResultado(data.sCre_SolicitudWeb);
            fetchDataCobranza();
        }
    }, [isOpen, data]);

    const fetchSelectResultado = async (id) => {
        setLoading(true);
        setError('');
        try {
            const response = await axios.get(APIURL.Cbo_GestorDeCobranzasOperativodet(id));


            // Extraer el objeto correctamente - puede ser Array o Objeto
            let datosDir = null;

            if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                datosDir = response.data.data[0]; // Primer elemento del array
            } else if (response.data.data && typeof response.data.data === 'object') {
                datosDir = response.data.data;
            } else if (Array.isArray(response.data) && response.data.length > 0) {
                datosDir = response.data[0];
            } else {
                datosDir = response.data;
            }


            setDireccionData(datosDir);
            setSelectResultado(response.data);
        } catch (error) {
            console.error("Error fetching Select Resultado:", error);
            setError('Error al cargar la información');
        } finally {
            setLoading(false);
        }
    };

    const handleOpen = (id) => {
        setSelectedId(id);
        setModalOpen(true);
    };

    const handleClose = () => {
        setModalOpen(false);
        setSelectedId(null);
    };

    const handleAbrirTelefonoConIdCompra = () => {
        if (!phoneAvailable) {
            setShowSaveGestion(true);
            return;
        }

        const idCompra = data?.idCompra ?? item?.idCompra ?? null;
        const cliente = data?.Cliente || item?.Cliente || '';
        const celular = data?.Celular || item?.Celular || '';

        openDialer({
            trackingId: idCompra,
            clientName: cliente,
            target: celular,
        });
    };


    const fetchDataCobranza = async () => {
        if (data && data.sCre_SolicitudWeb) {
            setLoading(true);
            setError('');
            try {
                const response = await axios.get(APIURL.getDetalleGestoresCobranzasDetalleOperativoWeb(data.idCompra, data.sCre_SolicitudWeb));

                setDatosCobranza(response.data);

                // Procesar el historial desde la API
                if (Array.isArray(response.data) && response.data.length > 0) {
                    setHistorialAPI(response.data);
                } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
                    setHistorialAPI(response.data.data);
                } else {
                    setHistorialAPI([]);
                }
            } catch (error) {
                console.error("Error fetching Datos Cobranza:", error);
                setError('Error al cargar la información de cobranza');
                setHistorialAPI([]);
            }
            finally {
                setLoading(false);
            }
        }
    };

    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 z-50 overflow-hidden">
            {/* Overlay */}
            <div className="absolute inset-0 bg-black/50 backdrop-blur-md transition-opacity" onClick={onClose}></div>

            {/* Modal */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="flex items-center justify-center min-h-screen p-4">
                    <div className="relative bg-white rounded-3xl shadow-2xl w-full max-w-7xl max-h-[95vh] overflow-hidden">
                        {/* Header Premium */}
                        <div className="relative bg-gradient-to-r from-slate-900 via-blue-800 to-slate-900 px-8 py-6 flex items-center justify-between overflow-hidden">
                            <div className="absolute inset-0 opacity-10">
                                <div className="absolute top-0 right-0 w-96 h-96 bg-blue-400 rounded-full mix-blend-multiply filter blur-3xl"></div>
                                <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-600 rounded-full mix-blend-multiply filter blur-3xl"></div>
                            </div>

                            <div className="relative flex-1 flex items-center gap-4">
                                <div className="p-3 bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl shadow-lg">
                                    <DocumentTextIcon className="w-7 h-7 text-white" />
                                </div>
                                <div className="text-white">
                                    <h2 className="text-2xl font-bold tracking-tight">Gestión de Cobranza</h2>
                                    <p className="text-blue-100 text-sm mt-1 flex items-center gap-2">
                                        <span className="inline-block w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
                                        Cliente: {item?.Cliente} | Cédula: {item?.Cedula}
                                    </p>
                                </div>
                            </div>
                            <button
                                onClick={onClose}
                                className="relative p-2.5 hover:bg-white/20 rounded-xl transition-all duration-200 hover:scale-110"
                            >
                                <XMarkIcon className="w-6 h-6 text-white" />
                            </button>
                        </div>


                        {/* Sección horizontal: Información de Dirección, Verificación Telefónica y Contacto */}
                        <div className="px-8 py-4 border-b border-slate-200">
                            <div className="flex flex-col md:flex-row gap-4 w-full">
                                {/* Acordeón: Información de Dirección */}
                                <div className="w-full md:w-[40%] min-w-[220px]">
                                    <button
                                        onClick={() => setShowDireccion((prev) => !prev)}
                                        className="flex items-center gap-2 px-4 py-2 bg-blue-100 hover:bg-blue-200 text-blue-800 font-semibold rounded-lg shadow-sm transition-all duration-200 w-full"
                                    >
                                        <MapPinIcon className="w-5 h-5" />
                                        Información de Dirección
                                        <span className={`ml-2 transition-transform duration-200 ${showDireccion ? 'rotate-90' : ''}`}>▶</span>
                                    </button>
                                    {showDireccion && (
                                        <div className="mt-4">
                                            <InfoDireccion direccionData={direccionData} loading={loading} />
                                        </div>
                                    )}
                                </div>
                                {/* Acordeón: Verificación Telefónica */}
                                <div className="w-full md:w-[40%] min-w-[220px]">
                                    <button
                                        onClick={() => setShowVerificacion((prev) => !prev)}
                                        className="flex items-center gap-2 px-4 py-2 bg-blue-100 hover:bg-blue-200 text-blue-800 font-semibold rounded-lg shadow-sm transition-all duration-200 w-full"
                                    >
                                        <PhoneIcon className="w-5 h-5" />
                                        Verificación Telefónica
                                        <span className={`ml-2 transition-transform duration-200 ${showVerificacion ? 'rotate-90' : ''}`}>▶</span>
                                    </button>
                                    {showVerificacion && (
                                        <div className="mt-4">
                                            <CardVerificacionTelefonica sCre_SolicitudWeb={data?.sCre_SolicitudWeb} estado={11} estadoGestion={estadoGestion} data={data} />
                                        </div>
                                    )}
                                </div>
                                {/* Botón Contacto */}
                               
                            </div>
                            {showTelefonos && (
                                <TelefonosNuevos
                                    isOpen={showTelefonos}
                                    onClose={() => setShowTelefonos(false)}
                                    item={direccionData}
                                />
                            )}
                        </div>
                        <div className="px-8 py-4 flex items-center justify-end border-b-2 border-slate-200">

                            <button
                                onClick={handleAbrirTelefonoConIdCompra}
                                disabled={(data?.idCompra ?? item?.idCompra ?? null) === null}
                                className="mr-4 flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:bg-slate-300 disabled:text-slate-500 text-white font-semibold rounded-lg shadow-md transition-all duration-200"
                                title={phoneAvailable ? 'Abrir teléfono para llamar' : 'Sin extensión asignada — registrar gestión manual'}
                            >
                                <PhoneIcon className="w-5 h-5" />
                                {phoneAvailable ? 'Llamar' : 'Gestión'}
                            </button>

                            <button onClick={() => handleOpen(data?.idCompra)} className="mr-4 p-1 bg-blue-600 hover:bg-blue-700 rounded-lg shadow-md transition-all duration-200">
                                <img
                                    src={simplia}
                                    alt="IconoSimplia"
                                    className="w-24 h-8 object-contain"
                                />
                            </button>
                            {/* BOTTON TELEFONOS CLIENTES*/}
                            <button onClick={() => setShowTelefonos(true)} className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-md transition-all duration-200">
                                <PhoneIcon className="w-5 h-5" />
                                Contacto
                            </button>
                        </div>
                        {showTelefonos && (
                            <TelefonosNuevos
                                isOpen={showTelefonos}
                                onClose={() => setShowTelefonos(false)}
                               item={direccionData}
                            />
                        )}

                        {/* Content - Scrollable */}
                        <div className="overflow-y-auto" style={{ maxHeight: 'calc(95vh - 250px)', paddingBottom: '100px' }}>
                            <div className="p-8">
                                {/* Historial de Gestiones (componente) */}
                                <HistorialGestiones historialAPI={historialAPI} estadoGestion={estadoGestion} data={data} />
                            </div>
                        </div>

                        {/* Footer - Botones Principales */}
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-slate-100 via-white to-transparent px-8 py-6 flex gap-4 justify-end border-t border-slate-200 shadow-2xl">
                            <button
                                onClick={onClose}
                                className="px-8 py-3 bg-white hover:bg-slate-50 text-slate-700 rounded-xl font-semibold transition-all duration-300 flex items-center gap-2.5 shadow-md hover:shadow-lg border-2 border-slate-300 hover:border-slate-400 transform hover:scale-105"
                            >
                                <XMarkIcon className="w-5 h-5" />
                                Cerrar
                            </button>
                            <button
                                onClick={() => setShowSaveGestion(true)}
                                className="px-8 py-3 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-600 hover:from-blue-600 hover:via-blue-700 hover:to-blue-700 text-white rounded-xl font-semibold transition-all duration-300 flex items-center gap-2.5 shadow-xl hover:shadow-2xl transform hover:scale-105 relative overflow-hidden group"
                            >
                                <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                                <PlusIcon className="w-5 h-5 relative" />
                                <span className="relative">Ingresar Gestión</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <SaveGestion
                isOpen={showSaveGestion}
                onClose={() => setShowSaveGestion(false)}
                estadoGestion={estadoGestion}
                datosCobranza={direccionData}
                data={data}
            />

            {/* Modal historial cobranza */}
            {modalOpen && (
                <HistorialCobranza
                    idCompra={selectedId}
                    onClose={handleClose}
                />
            )}
        </div>
    );
}


